import React, { useState, useEffect } from "react";
import PedidoRealizadoModal from '../Modal/ModalSeleccion.jsx';
import ModalConfirmacion from '../Modal/ModalConfirmacion.jsx';
import ModalPedidoExistente from '../Modal/ModalPedidoExistente.jsx';
import { useNavigate } from 'react-router-dom';
import axios from "axios";


const apiUrlMenuSemanals = process.env.REACT_APP_API_MENUSEMANALS;
const apiUrlPedidos = process.env.REACT_APP_API_PEDIDOS;

const diasDeLaSemana = ["Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"];

const getTipoItem = (item) => {
  if (item?.bebida_id != null) {
    return item?.bebida?.tipo || item?.tipo || 'Bebida';
  }
  return item?.plato?.tipoplato?.nombre || item?.tipoplato?.nombre || item?.tipo || 'Sin clasificar';
};

const Seleccion = () => {
  const [esEditable, setEsEditable] = useState(true);
  const [cutoffMessage, setCutoffMessage] = useState('');
  const [platos, setPlatos] = useState([]);
  const [error, setError] = useState(null);
  const [selectedPlatos, setSelectedPlatos] = useState({});
  const [pedidosExistentes, setPedidosExistentes] = useState([]); // NUEVO: guardar pedidos existentes
  const [hasExistingPedido, setHasExistingPedido] = useState(false);
  const [loadingLockState, setLoadingLockState] = useState(true);
  const [showModalConfirmacion, setShowModalConfirmacion] = useState(false);
  const [showModalPedidoRealizado, setShowModalPedidoRealizado] = useState(false);
  const [showModalPedidoExistente, setShowModalPedidoExistente] = useState(false);
  const [mensajeModalExistente, setMensajeModalExistente] = useState('');
  const [observacion, setObservacion] = useState({});
  const [expandedDays, setExpandedDays] = useState({});
  const sedeUsuario = localStorage.getItem("id_sede") ? String(localStorage.getItem("id_sede")) : "";
  const navegate = useNavigate();

  const toggleDay = (fecha, comida) => {
    const key = `${fecha}-${comida}`;
    setExpandedDays(prev => ({ ...prev, [key]: !prev[key] }));
  };

  // Verificar si estamos en período de pedidos consultando la API
  useEffect(() => {
    const verificarCorte = async () => {
      try {
        const token = sessionStorage.getItem('token');
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/config/cutoff`, {
          headers: { 'Authorization': `Bearer ${token}` }
        });

        const configs = response.data || {};
        const idSedeNum = sedeUsuario ? parseInt(sedeUsuario, 10) : null;

        // Buscar config específica de la sede o default
        let cutoffConfig = null;
        if (idSedeNum) {
          cutoffConfig = configs[`CUTOFF_CREATE_SEDE_${idSedeNum}`] || configs[`CUTOFF_SEDE_${idSedeNum}`];
        }
        if (!cutoffConfig) {
          cutoffConfig = configs['CUTOFF_CREATE_DEFAULT'] || configs['CUTOFF_DEFAULT'];
        }

        // Si no hay config, usar default: Miércoles 10:00
        const day = cutoffConfig?.day ?? 3;
        const time = cutoffConfig?.time ?? '10:00';

        const ahora = new Date();
        const dow = ahora.getDay();
        const corte = new Date(ahora);
        corte.setDate(ahora.getDate() - dow + day);
        const [hh, mm] = time.split(':').map(n => parseInt(n, 10));
        corte.setHours(hh || 10, mm || 0, 0, 0);

        const yaPaso = ahora >= corte;
        setEsEditable(!yaPaso);

        if (yaPaso) {
          const dias = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'];
          setCutoffMessage(`No se pueden crear ni modificar pedidos después del ${dias[day]} a las ${time}. La selección de menús está disponible desde el lunes hasta el ${dias[day]} a las ${time}.`);
        }
      } catch (err) {
        // Si falla la API (401 = no autenticado, 403 = sin permisos), permitir por defecto
        // Solo loguear si no es un error de autenticación esperado
        if (err.response?.status !== 401 && err.response?.status !== 403) {
          console.warn('Error al verificar corte:', err.message);
        }
        setEsEditable(true);
      }
    };

    verificarCorte();
  }, [sedeUsuario]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const sede = sedeUsuario;
        console.log('[Seleccion] id_sede usuario:', sede);

        const responsePlatos = await axios.get(apiUrlMenuSemanals);
        const platosData = responsePlatos.data;

        // Calcular rango de la semana próxima (lunes a domingo siguiente)
        const today = new Date();
        const nextMonday = new Date(today);
        const day = today.getDay(); // 0=Domingo .. 6=Sabado
        // Si hoy es lunes (day=1), la semana próxima empieza en 7 días
        // Si hoy es domingo (day=0), la semana próxima empieza mañana (lunes)
        const daysUntilMonday = day === 0 ? 1 : day === 1 ? 7 : (8 - day);
        nextMonday.setDate(today.getDate() + daysUntilMonday);
        nextMonday.setHours(0, 0, 0, 0);
        const nextSunday = new Date(nextMonday);
        nextSunday.setDate(nextMonday.getDate() + 6);
        nextSunday.setHours(23, 59, 59, 999);

        // Formatear fechas a YYYY-MM-DD para comparación
        const formatDate = (d) => {
          const yyyy = d.getFullYear();
          const mm = String(d.getMonth() + 1).padStart(2, '0');
          const dd = String(d.getDate()).padStart(2, '0');
          return `${yyyy}-${mm}-${dd}`;
        };
        const nextMondayStr = formatDate(nextMonday);
        const nextSundayStr = formatDate(nextSunday);

        console.log('[Seleccion] Rango semana próxima:', nextMondayStr, 'a', nextSundayStr);

        // Filtrar por sede Y por semana próxima, normalizando la fecha y evitando duplicados
        const cacheDuplicados = new Set();
        const platosFiltrados = platosData
          .map(plato => {
            const idSedePlato = plato.id_sede != null ? Number(plato.id_sede) : null;
            const idSedeUsuario = sede ? Number(sede) : null;
            const mismaSede = idSedePlato && idSedeUsuario && idSedePlato === idSedeUsuario;

            if (!mismaSede) return null;

            // Normalizar fecha
            const fechaPlato = plato.fecha ? plato.fecha.split('T')[0] : null;
            if (!fechaPlato) return null;

            const enRango = fechaPlato >= nextMondayStr && fechaPlato <= nextSundayStr;

            if (enRango) {
              // Crear una clave única para detectar duplicados (misma sede, fecha, comida y plato/bebida)
              const comidaNormalizada = (plato.comida || 'almuerzo').toLowerCase().trim();
              const key = `${fechaPlato}_${comidaNormalizada}_${plato.id_plato || 'bebida'}_${plato.bebida_id || 'plato'}_${plato.nombre}`;

              if (cacheDuplicados.has(key)) {
                return null; // Ya incluimos este plato para esta fecha/comida
              }

              cacheDuplicados.add(key);
              return { ...plato, fecha: fechaPlato };
            }
            return null;
          })
          .filter(p => p !== null);

        console.log('[Seleccion] Total platos mostrados (semana próxima):', platosFiltrados.length);
        console.log('[Seleccion] Detalle de platos cargados:');
        platosFiltrados.forEach(p => {
          console.log(`  - ${p.nombre} | fecha: ${p.fecha} | comida: "${p.comida}" | tipo: ${getTipoItem(p)} | bebida_id: ${p.bebida_id} | id_plato: ${p.id_plato}`);
        });
        setPlatos(platosFiltrados);
      } catch (error) {
        console.error("Error al obtener datos:", error);
        setError("Error al obtener los menús semanales.");
      }
    };

    if (sedeUsuario) {
      fetchData();
    }
  }, [sedeUsuario]);

  // Bloqueo: si usuario ya tiene pedidos para la semana próxima (lunes-domingo siguiente) no puede crear nuevos, sólo editar.
  // EXCEPCIÓN: usuarios tipo "invitados" o "dirección" pueden crear múltiples pedidos
  useEffect(() => {
    const checkExistingPedido = async () => {
      setLoadingLockState(true);
      try {
        const usuario = localStorage.getItem("nombreUsuario");
        const tipoUsuario = localStorage.getItem("tipoUsuario")?.toLowerCase();

        if (!usuario) {
          setHasExistingPedido(false);
          return;
        }

        // Usuarios "invitados" y "dirección" pueden hacer múltiples pedidos
        const puedeHacerMultiplesPedidos = tipoUsuario === 'invitados' || tipoUsuario === 'dirección';

        if (puedeHacerMultiplesPedidos) {
          console.log('[Seleccion] Usuario tipo', tipoUsuario, '- puede hacer múltiples pedidos');
          setHasExistingPedido(false);
          setLoadingLockState(false);
          return;
        }

        // Calcular rango semana próxima
        const today = new Date();
        const nextMonday = new Date(today);
        const day = today.getDay(); // 0=Domingo .. 6=Sabado
        // Si hoy es lunes (day=1), la semana próxima empieza en 7 días
        // Si hoy es domingo (day=0), la semana próxima empieza mañana (lunes)
        const daysUntilMonday = day === 0 ? 1 : day === 1 ? 7 : (8 - day);
        nextMonday.setDate(today.getDate() + daysUntilMonday);
        nextMonday.setHours(0, 0, 0, 0);
        const nextSunday = new Date(nextMonday);
        nextSunday.setDate(nextMonday.getDate() + 6);
        nextSunday.setHours(23, 59, 59, 999);

        console.log('[Seleccion] Verificando pedidos para usuario:', usuario, 'tipo:', tipoUsuario);
        console.log('[Seleccion] Rango semana próxima:', nextMonday.toISOString(), 'a', nextSunday.toISOString());

        // Obtener pedidos del usuario usando el endpoint específico
        const apiUrlVistaPedidos = process.env.REACT_APP_API_VISTAPEDIDOS;
        const response = await axios.get(`${apiUrlVistaPedidos}${usuario}`);
        const pedidosUsuario = Array.isArray(response.data) ? response.data : [];

        console.log('[Seleccion] Pedidos del usuario encontrados:', pedidosUsuario.length);
        console.log('[Seleccion] Pedidos completos:', pedidosUsuario);

        // Guardar pedidos existentes para validación posterior
        setPedidosExistentes(pedidosUsuario);

        // Comparar sólo la parte fecha (YYYY-MM-DD) para evitar problemas de zona horaria
        const isoDate = (d) => {
          try {
            return new Date(d).toISOString().slice(0, 10);
          } catch (err) {
            return null;
          }
        };
        const nextMondayStr = isoDate(nextMonday);
        const nextSundayStr = isoDate(nextSunday);

        const yaTiene = pedidosUsuario.some(p => {
          if (!p.fecha) return false;
          const pDateStr = isoDate(p.fecha);
          if (!pDateStr) return false;
          const dentroRangoStr = pDateStr >= nextMondayStr && pDateStr <= nextSundayStr;
          if (dentroRangoStr) {
            console.log('[Seleccion] Pedido existente en rango (fecha-normalizada):', p.id_pedido, p.fecha, pDateStr, p.nombre);
          } else {
            console.log('[Seleccion] Pedido fuera de rango (fecha-normalizada):', p.id_pedido, p.fecha, pDateStr);
          }
          return dentroRangoStr;
        });

        console.log('[Seleccion] ¿Ya tiene pedidos para semana próxima?', yaTiene);
        setHasExistingPedido(yaTiene);
        if (yaTiene) setShowModalPedidoRealizado(true);
      } catch (error) {
        console.error("Error al verificar el pedido existente:", error);
        setHasExistingPedido(false); // fallback: permitir si error
      } finally {
        setLoadingLockState(false);
      }
    };
    checkExistingPedido();
  }, []);

  const handleCheckboxChange = (fecha, tipo, plato) => {
    // Solo bloquear si está cargando
    if (loadingLockState) return;

    // VERIFICAR: si ya existe pedido guardado para esta fecha+comida específica
    const tipoUsuario = (localStorage.getItem('tipoUsuario') || '').toLowerCase();
    const esInvitadoODireccion = tipoUsuario === 'invitado' || tipoUsuario === 'dirección';

    if (!esInvitadoODireccion) {
      const comida = (plato.comida || '').toLowerCase().trim();
      const fechaNormalizada = fecha.split('T')[0]; // YYYY-MM-DD

      const pedidoExistente = pedidosExistentes.find(p => {
        const fechaPedido = new Date(p.fecha).toISOString().slice(0, 10);
        const comidaPedido = (p.comida || '').toLowerCase().trim();
        return fechaPedido === fechaNormalizada && comidaPedido === comida;
      });

      if (pedidoExistente) {
        console.log('[Seleccion] Detectado pedido existente, mostrando modal');
        setMensajeModalExistente(`Ya tenés un pedido guardado para ${comida} del ${fechaNormalizada}.`);
        setShowModalPedidoExistente(true);
        return;
      }
    }

    setSelectedPlatos(prevSelectedPlatos => {
      const updatedSelection = { ...prevSelectedPlatos };
      const comida = (plato.comida || '').toLowerCase().trim();
      // Clave única que incluya si es bebida o plato para diferenciar
      const esBebida = plato.bebida_id != null;
      const platoKey = `${plato.idmenu_semanal || plato.id_plato || plato.id || plato.nombre}${esBebida ? '_bebida' : '_plato'}`;

      if (!updatedSelection[fecha]) {
        updatedSelection[fecha] = {};
      }
      if (!updatedSelection[fecha][comida]) {
        updatedSelection[fecha][comida] = {};
      }

      const isSelected = !!updatedSelection[fecha][comida][platoKey];

      if (isSelected) {
        // Si ya estaba seleccionado, lo quitamos
        delete updatedSelection[fecha][comida][platoKey];
      } else {
        // Si no estaba seleccionado, lo agregamos

        // REGLA DE NEGOCIO: Se puede elegir UN plato Y UNA bebida por comida
        // Solo 'invitado' puede pedir múltiples items del mismo tipo
        const tipoUsuario = (localStorage.getItem('tipoUsuario') || '').toLowerCase();
        const esInvitado = tipoUsuario === 'invitado';

        if (!esInvitado) {
          // Quitamos el anterior del MISMO tipo (si selecciono otro plato, quito el plato anterior, pero mantengo la bebida)
          // Las bebidas tienen bebida_id, los platos tienen id_plato
          const esBebida = plato.bebida_id != null;

          Object.keys(updatedSelection[fecha][comida]).forEach(key => {
            const itemExistente = updatedSelection[fecha][comida][key];
            const itemExistenteEsBebida = itemExistente.bebida_id != null;

            // Solo eliminar si son del mismo tipo (ambos platos o ambas bebidas)
            if (esBebida === itemExistenteEsBebida) {
              delete updatedSelection[fecha][comida][key];
            }
          });
        }

        // Agregamos el nuevo item
        updatedSelection[fecha][comida][platoKey] = plato;
      }

      if (Object.keys(updatedSelection[fecha][comida]).length === 0) {
        delete updatedSelection[fecha][comida];
      }
      if (Object.keys(updatedSelection[fecha]).length === 0) {
        delete updatedSelection[fecha];
      }
      return updatedSelection;
    });

    if (!observacion[fecha]) {
      setObservacion(prevObservaciones => ({
        ...prevObservaciones,
        [fecha]: "",
      }));
    }
  };

  // Funciones para el modal de pedido existente
  const handleVerMiPedido = () => {
    setShowModalPedidoExistente(false);
    setShowModalPedidoRealizado(false);

    // Detectar tipo de usuario para navegar a la ruta correcta
    const tipoUsuario = (localStorage.getItem('tipoUsuario') || '').toLowerCase();
    const esAdmin = tipoUsuario === 'admin' || tipoUsuario === 'superadmin';

    if (esAdmin) {
      navegate('/admin/mipedidosemanal');
    } else {
      navegate('/user/mipedidosemanal');
    }
  };

  const handleEliminarYRehacer = async () => {
    try {
      const usuario = localStorage.getItem('nombreUsuario');
      const apiUrlBase = process.env.REACT_APP_API_URL;

      // Obtener todos los pedidos del usuario
      const apiUrlVistaPedidos = process.env.REACT_APP_API_VISTAPEDIDOS;
      const response = await axios.get(`${apiUrlVistaPedidos}${usuario}`);
      const todosPedidos = response.data || [];

      console.log('[handleEliminarYRehacer] Total pedidos del usuario:', todosPedidos.length);

      if (todosPedidos.length === 0) {
        alert('No hay pedidos para eliminar.');
        setShowModalPedidoRealizado(false);
        setShowModalPedidoExistente(false);
        return;
      }

      const confirmado = window.confirm(`¿Estás seguro que querés eliminar TODOS tus pedidos (${todosPedidos.length} en total)?`);
      if (!confirmado) return;

      // Eliminar TODOS los pedidos del usuario
      console.log('[handleEliminarYRehacer] Eliminando pedidos:', todosPedidos.map(p => p.id_pedido));
      const promesas = todosPedidos.map(pedido =>
        axios.delete(`${apiUrlBase}/seleccion/${pedido.id_pedido}`)
      );

      await Promise.all(promesas);

      alert(`Se eliminaron ${todosPedidos.length} pedido(s). Ahora podés volver a seleccionar.`);
      setShowModalPedidoRealizado(false);
      setShowModalPedidoExistente(false);

      // Recargar la página para actualizar el estado
      window.location.reload();
    } catch (error) {
      console.error('Error al eliminar pedidos:', error);
      alert('Error al eliminar los pedidos. Intentá de nuevo.');
    }
  };

  const enviarSeleccionABaseDeDatos = async () => {
    try {
      if (hasExistingPedido || !isAnyPlatoSelected() || loadingLockState) {
        return;
      }

      setLoadingLockState(true);

      const sector = localStorage.getItem("sector");
      const ubicacion = localStorage.getItem("ubicación");
      const idSede = localStorage.getItem('id_sede');
      const idUsuario = localStorage.getItem('id');
      const usuario = localStorage.getItem("nombreUsuario");
      const apellido = localStorage.getItem("apellido");
      // Usar nombreUsuario para nombreuser
      const nombreUser = localStorage.getItem("nombreUsuario");

      // Agrupar platos y bebidas del mismo día/comida en un solo pedido
      const pedidosAgrupados = {};

      Object.keys(selectedPlatos).forEach(fecha => {
        Object.keys(selectedPlatos[fecha]).forEach(tipo => {
          const key = `${fecha}-${tipo}`; // clave única por día+comida

          if (!pedidosAgrupados[key]) {
            pedidosAgrupados[key] = {
              id_sede: idSede ? Number(idSede) : null,
              id_usuario: idUsuario ? Number(idUsuario) : null,
              id_plato: null,
              bebida_id: null,
              nombre: null,
              tipo: null,
              fecha: fecha,
              usuario: usuario,
              nombreuser: nombreUser,
              apellido: apellido,
              sector: sector,
              ubicacion: ubicacion,
              observacion: observacion[fecha] || "null",
              comida: tipo,
            };
          }

          // Agregar cada item al pedido agrupado
          Object.keys(selectedPlatos[fecha][tipo]).forEach(platoId => {
            const item = selectedPlatos[fecha][tipo][platoId];
            const esBebida = item.bebida_id != null;

            if (esBebida) {
              pedidosAgrupados[key].bebida_id = item.bebida_id;
            } else {
              pedidosAgrupados[key].id_plato = item.id_plato;
              pedidosAgrupados[key].nombre = item.nombre;
              pedidosAgrupados[key].tipo = null;
            }
          });
        });
      });

      const seleccion = Object.values(pedidosAgrupados);

      const payload = { nuevosPlatos: seleccion };
      console.log('[Seleccion] URL POST:', apiUrlPedidos);
      console.log('[Seleccion] Payload a enviar (nuevosPlatos):', payload);
      console.log('[Seleccion] Usuario:', usuario, 'NombreUser:', nombreUser);
      const response = await axios.post(apiUrlPedidos, payload);
      console.log('[Seleccion] Respuesta POST:', response.status, response.data);
      console.log('[Seleccion] Pedidos creados exitosamente para usuario:', nombreUser);
      alert('Selección enviada correctamente.');

      setSelectedPlatos({});
      setShowModalConfirmacion(false);
      setObservacion({});
      // Redirigir según tipo de usuario: admin -> /admin/mipedidosemanal, otros -> /user/mipedidosemanal
      const tipo = localStorage.getItem('tipoUsuario');
      if (tipo && String(tipo).toLowerCase() === 'admin') {
        navegate('/admin/mipedidosemanal');
      } else {
        navegate('/user/mipedidosemanal');
      }
    } catch (error) {
      console.error("Error al enviar la selección a la base de datos:", error);
      alert('Error al enviar selección: ' + (error.response?.data?.message || error.message));
    } finally {
      setLoadingLockState(false);
    }
  };

  const isAnyPlatoSelected = () => {
    return Object.keys(selectedPlatos).some(
      fecha => Object.keys(selectedPlatos[fecha]).some(
        tipo => Object.keys(selectedPlatos[fecha][tipo]).length > 0
      )
    );
  };

  // Obtener lista única de fechas de los platos ya filtrados y ordenarlos
  const fechasUnicas = [...new Set(platos.map(p => p.fecha))].sort();

  const parseFechaLocal = (fechaStr) => {
    if (!fechaStr) return new Date();
    // Dividir YYYY-MM-DD
    const [year, month, day] = fechaStr.split('-').map(Number);
    // Crear fecha en zona horaria local
    return new Date(year, month - 1, day);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-cyan-50 to-teal-50 py-8 px-4">
      <div className="max-w-6xl mx-auto">
        {/* Header */}
        <div className="bg-white rounded-2xl shadow-xl p-6 mb-6 border-b-4 border-blue-500">
          <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
            <div className="flex items-center gap-4">
              <div className="bg-gradient-to-br from-blue-500 to-cyan-600 p-4 rounded-xl shadow-lg">
                <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01" />
                </svg>
              </div>
              <div>
                <h1 className="text-3xl font-bold text-gray-800">Selección de Menú</h1>
                <p className="text-gray-600 mt-1">Elige tus platos para la próxima semana</p>
              </div>
            </div>

            <button
              onClick={() => {
                if (isAnyPlatoSelected()) {
                  setShowModalConfirmacion(true);
                }
              }}
              className={`px-6 py-3 rounded-lg text-white font-bold transition-all duration-200 shadow-lg flex items-center gap-2
                ${loadingLockState ? 'bg-gray-400 cursor-wait' : hasExistingPedido || !isAnyPlatoSelected() || !esEditable
                  ? 'bg-gray-400 cursor-not-allowed'
                  : 'bg-gradient-to-r from-green-500 to-emerald-600 hover:from-green-600 hover:to-emerald-700 transform hover:scale-105'}
              `}
              disabled={loadingLockState || hasExistingPedido || !isAnyPlatoSelected() || !esEditable}
            >
              {loadingLockState ? (
                <>
                  <svg className="animate-spin h-5 w-5" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none" />
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
                  </svg>
                  Verificando...
                </>
              ) : hasExistingPedido ? (
                <>
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                  Pedido ya registrado
                </>
              ) : !esEditable ? (
                <>
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                  </svg>
                  Edición cerrada
                </>
              ) : (
                <>
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                  Enviar Selección
                </>
              )}
            </button>
          </div>
        </div>

        {/* Alertas */}
        {!esEditable && (
          <div className="bg-amber-50 border-l-4 border-amber-500 p-4 rounded-r-lg shadow-md mb-6">
            <div className="flex items-start gap-3">
              <svg className="w-6 h-6 text-amber-600 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
              </svg>
              <div>
                <p className="font-semibold text-amber-900">Período de selección cerrado</p>
                <p className="text-sm text-amber-700 mt-1">
                  {cutoffMessage || 'No se pueden crear ni modificar pedidos después del horario de corte configurado.'}
                </p>
              </div>
            </div>
          </div>
        )}

        {error && (
          <div className="bg-red-50 border-l-4 border-red-500 p-4 rounded-r-lg shadow-md mb-6">
            <div className="flex items-start gap-3">
              <svg className="w-6 h-6 text-red-600 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
              </svg>
              <p className="text-sm text-red-700">{error}</p>
            </div>
          </div>
        )}

        {hasExistingPedido && !loadingLockState && (
          <div className="bg-blue-50 border-l-4 border-blue-500 p-4 rounded-r-lg shadow-md mb-6">
            <div className="flex items-start gap-3">
              <svg className="w-6 h-6 text-blue-600 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
              </svg>
              <div>
                <p className="font-semibold text-blue-900">Pedido registrado</p>
                <p className="text-sm text-blue-700 mt-1">
                  Ya registraste tu pedido para la semana próxima. Sólo puedes editar desde la vista de pedido semanal.
                </p>
              </div>
            </div>
          </div>
        )}

        {/* Contenido del menú */}
        <div className="space-y-4">
          {fechasUnicas.map(fecha => (
            <div
              key={fecha}
              className="bg-white rounded-xl shadow-lg overflow-hidden border border-gray-200"
            >
              {/* Header del día */}
              <div className="bg-gradient-to-r from-cyan-500 to-blue-600 px-6 py-4">
                <div className="flex items-center gap-3">
                  <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                  </svg>
                  <h3 className="text-xl font-bold text-white">
                    {diasDeLaSemana[parseFechaLocal(fecha).getDay()]} –{" "}
                    {parseFechaLocal(fecha).toLocaleDateString('es-AR', {
                      day: 'numeric',
                      month: 'long',
                      year: 'numeric',
                    })}
                  </h3>
                </div>
              </div>

              {/* Comidas del día */}
              <div className="p-4 space-y-3">
                {["almuerzo", "cena"].map(comida => {
                  const key = `${fecha}-${comida}`;
                  const isExpanded = expandedDays[key];
                  const platosDeComida = platos.filter(plato => {
                    const fechaMatch = plato.fecha === fecha;
                    const platoComida = (plato.comida || '').toLowerCase().trim();
                    const comidaBuscada = comida.toLowerCase().trim();
                    return fechaMatch && platoComida === comidaBuscada;
                  });

                  return (
                    <div key={key} className="border border-gray-200 rounded-lg overflow-hidden">
                      {/* Header del acordeón */}
                      <button
                        onClick={() => toggleDay(fecha, comida)}
                        className="w-full bg-gradient-to-r from-blue-50 to-cyan-50 hover:from-blue-100 hover:to-cyan-100 px-4 py-3 flex items-center justify-between transition-colors"
                      >
                        <div className="flex items-center gap-3">
                          <div className={`w-2 h-2 rounded-full ${comida === 'almuerzo' ? 'bg-orange-500' : 'bg-purple-500'}`} />
                          <span className="font-semibold text-gray-800 text-lg">
                            {comida === 'almuerzo' ? '🍽️ Almuerzo' : '🌙 Cena'}
                          </span>
                          <span className="text-sm text-gray-500">
                            ({platosDeComida.length} {platosDeComida.length === 1 ? 'opción' : 'opciones'})
                          </span>
                        </div>
                        <svg
                          className={`w-5 h-5 text-gray-600 transition-transform ${isExpanded ? 'rotate-180' : ''}`}
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                        </svg>
                      </button>

                      {/* Contenido del acordeón */}
                      {isExpanded && (
                        <div className="p-4 bg-gray-50">
                          {/* Separar platos de bebidas */}
                          {(() => {
                            const platosSinBebidas = platosDeComida.filter(p => !p.bebida_id);
                            const bebidas = platosDeComida.filter(p => p.bebida_id);

                            return (
                              <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-4">
                                {/* Columna izquierda: Platos */}
                                <div>
                                  {platosSinBebidas.length > 0 && (
                                    <div className="bg-gradient-to-br from-orange-50 to-amber-50 rounded-lg border-2 border-orange-200 p-3">
                                      <h4 className="text-sm font-bold text-orange-700 mb-3 flex items-center gap-2">
                                        🍽️ Platos
                                      </h4>
                                      <div className="space-y-2">
                                        {platosSinBebidas.map(plato => {
                                          const esBebida = plato.bebida_id != null;
                                          const platoKey = `${plato.idmenu_semanal || plato.id_plato || plato.id || plato.nombre}${esBebida ? '_bebida' : '_plato'}`;
                                          const isChecked = !!selectedPlatos[fecha]?.[comida]?.[platoKey];
                                          const isDisabled = loadingLockState || hasExistingPedido || !esEditable;

                                          return (
                                            <label
                                              key={platoKey}
                                              className={`flex items-start gap-3 p-3 rounded-lg border-2 transition-all ${isDisabled
                                                ? 'opacity-50 cursor-not-allowed bg-gray-100'
                                                : isChecked
                                                  ? 'bg-green-50 border-green-500 shadow-md cursor-pointer hover:shadow-lg'
                                                  : 'bg-white border-gray-200 cursor-pointer hover:border-orange-300 hover:shadow-md'
                                                }`}
                                            >
                                              <input
                                                type="checkbox"
                                                className="w-5 h-5 mt-0.5 accent-green-500 flex-shrink-0 cursor-pointer"
                                                checked={isChecked}
                                                onChange={() => handleCheckboxChange(fecha, plato.comida, plato)}
                                                disabled={isDisabled}
                                              />
                                              <div>
                                                <span className="font-medium text-gray-900 block text-sm">
                                                  {plato.nombre}
                                                </span>
                                                <span className="text-xs text-gray-500 italic">
                                                  {getTipoItem(plato)}
                                                </span>
                                              </div>
                                            </label>
                                          );
                                        })}
                                      </div>
                                    </div>
                                  )}
                                </div>

                                {/* Columna derecha: Bebidas */}
                                <div>
                                  {bebidas.length > 0 && (
                                    <div className="bg-gradient-to-br from-blue-50 to-cyan-50 rounded-lg border-2 border-blue-200 p-3">
                                      <h4 className="text-sm font-bold text-blue-700 mb-3 flex items-center gap-2">
                                        🥤 Bebidas
                                      </h4>
                                      <div className="space-y-2">
                                        {bebidas.map(plato => {
                                          const esBebida = plato.bebida_id != null;
                                          const platoKey = `${plato.idmenu_semanal || plato.id_plato || plato.id || plato.nombre}${esBebida ? '_bebida' : '_plato'}`;
                                          const isChecked = !!selectedPlatos[fecha]?.[comida]?.[platoKey];
                                          const isDisabled = loadingLockState || hasExistingPedido || !esEditable;

                                          return (
                                            <label
                                              key={platoKey}
                                              className={`flex items-start gap-3 p-3 rounded-lg border-2 transition-all ${isDisabled
                                                ? 'opacity-50 cursor-not-allowed bg-gray-100'
                                                : isChecked
                                                  ? 'bg-green-50 border-green-500 shadow-md cursor-pointer hover:shadow-lg'
                                                  : 'bg-white border-gray-200 cursor-pointer hover:border-blue-300 hover:shadow-md'
                                                }`}
                                            >
                                              <input
                                                type="checkbox"
                                                className="w-5 h-5 mt-0.5 accent-green-500 flex-shrink-0 cursor-pointer"
                                                checked={isChecked}
                                                onChange={() => handleCheckboxChange(fecha, plato.comida, plato)}
                                                disabled={isDisabled}
                                              />
                                              <div>
                                                <span className="font-medium text-gray-900 block text-sm">
                                                  {plato.nombre}
                                                </span>
                                                <span className="text-xs text-blue-500 italic">
                                                  {getTipoItem(plato)}
                                                </span>
                                              </div>
                                            </label>
                                          );
                                        })}
                                      </div>
                                    </div>
                                  )}
                                </div>
                              </div>
                            );
                          })()}
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
          ))}
        </div>

        {/* Info box */}
        <div className="mt-8 bg-gradient-to-br from-blue-50 to-cyan-50 rounded-xl p-6 border-2 border-blue-200 shadow-md">
          <div className="flex items-start gap-4">
            <div className="bg-blue-500 p-3 rounded-lg flex-shrink-0">
              <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            </div>
            <div>
              <h4 className="font-bold text-lg text-gray-800 mb-2">💡 Instrucciones</h4>
              <ul className="space-y-1 text-gray-700 text-sm">
                <li>• Haz clic en cada comida (almuerzo/cena) para expandir las opciones</li>
                <li>• Marca los platos que deseas para cada día</li>
                <li>• Puedes seleccionar múltiples opciones por comida</li>
                <li>• Recuerda enviar tu selección antes del horario de corte</li>
                <li>• Una vez enviado, solo podrás editarlo desde "Vista Pedido Semanal"</li>
              </ul>
            </div>
          </div>
        </div>
      </div >

      {/* Modales */}
      {
        showModalPedidoRealizado && (
          <PedidoRealizadoModal
            show={showModalPedidoRealizado}
            handleClose={() => setShowModalPedidoRealizado(false)}
            onEliminarYRehacer={handleEliminarYRehacer}
            onVerMiPedido={handleVerMiPedido}
          />
        )
      }

      <ModalConfirmacion
        show={showModalConfirmacion}
        handleClose={() => setShowModalConfirmacion(false)}
        handleConfirm={enviarSeleccionABaseDeDatos}
      />

      <ModalPedidoExistente
        show={showModalPedidoExistente}
        handleClose={() => setShowModalPedidoExistente(false)}
        handleVerMiPedido={handleVerMiPedido}
        handleEliminarYRehacer={handleEliminarYRehacer}
        mensaje={mensajeModalExistente}
      />
    </div >
  );
};

export default Seleccion;
